exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.image-icon[data-v-69f7f43f] {\n  left: 25%;\n}\n.img-div:hover .image-icon[data-v-69f7f43f] {\n  color: #212121;\n}\n.youtube-link[data-v-69f7f43f] {\n  padding: 0.45rem;\n  background: transparent;\n  border-color: #de1a23;\n  border-style: solid;\n  border-width: 1px;\n}\n.progress[data-v-69f7f43f] {\n  margin-right: auto;\n  margin-left: 2rem;\n}\n", ""]);

// exports
